import { BackButton } from '@common/components/BackButton';
import { Title } from '@common/components/Title';
import { Layout } from '@common/layouts';
import { Background } from '@features/Collection';
import {
    Box,
    Card,
    Flex,
    ScrollArea,
    Section,
    Skeleton,
    Theme,
} from '@radix-ui/themes';
import { useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ClipPlayer } from '../components/ClipPlayer';
import { HistorySection } from '../components/HistorySection';
import { InfoSection } from '../components/InfoSection';
import { ProgramLink } from '../components/ProgramLink';
import { useSelectedClip } from '../hooks/useSelectedClipSelectors';

export const AssetDetailsPage = () => {
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    useTranslation();
    const {
        selectedClip: { clipName },
        isLoading,
    } = useSelectedClip();

    return (
        <Background scrollRef={scrollContainerRef}>
            <ScrollArea ref={scrollContainerRef} type={'scroll'}>
                <Box m={'3'} height={'100%'}>
                    <BackButton />

                    <Flex
                        direction={'column'}
                        gap={'2'}
                        height={'100%'}
                        // m={'3'}
                        px={'5'}
                    >
                        <Box asChild>
                            <Section size={'1'}>
                                <Section>
                                    <Flex direction={'column'} gap={'4'}>
                                        <Title mb={'0'}>
                                            <Skeleton loading={isLoading}>
                                                {clipName}
                                            </Skeleton>
                                        </Title>
                                        <ProgramLink />
                                    </Flex>
                                </Section>
                                <Section size={'1'}>
                                    <Flex gap={'9'}>
                                        <InfoSection />
                                        <ClipPlayer />
                                    </Flex>
                                </Section>
                                <Section>
                                    <HistorySection />
                                </Section>
                                <Section>
                                    <Theme radius='none'>
                                        <Card
                                            variant={'surface'}
                                            style={{ borderRadius: 'none' }}
                                        >
                                            <Layout.Content
                                                direction={'row'}
                                                gap={'2'}
                                                overflow={'hidden'}
                                            >
                                                <Box p={'5'}>
                                                    <Trans
                                                        i18nKey={
                                                            'clipDetails:associatedFiles'
                                                        }
                                                    />
                                                </Box>
                                            </Layout.Content>
                                        </Card>
                                    </Theme>
                                </Section>
                            </Section>
                        </Box>
                    </Flex>
                </Box>
            </ScrollArea>
        </Background>
    );
};
